import React from "react";


// Define the styles type to make sure styles are type-safe
const styles: Record<string, React.CSSProperties> = {
    container: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        backgroundColor: "#e6f7f9",
        padding: "24px",
        borderRadius: "16px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        gap: "16px",
    },
    imageContainer: {
        width: "125px",
        height: "125px",
        borderRadius: "50%",
        overflow: "hidden",

    },
    image: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        // backgroundImage: `url("../../../../public/assets/images/user/profile_user.png")`,
        backgroundSize: "cover",
    },
    detailsContainer: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
        gap: "20px",
        width: "100%",
    },
    headerContainer: {
        textAlign: "center",
    },
    nameText: {
        fontSize: "18px",
        fontWeight: "bold",
        color: '#000000'
    },
    emailText: {
        fontSize: "14px",
        color: "#888",
    },
    detailItem: {
        display: "flex",
        flexDirection: "column",
        gap: "0px",
    },
    label: {
        fontSize: "12px",
        color: "#888",
    },
    value: {
        fontSize: "14px",
        fontWeight: "500",
        color: '#000000'

    },
};


type DataProps = {
    data: {
        EmployeeName?: string;
        EmployeeCode?: any;
        EmployeeEmail?: any;
        PositionName?: any;
        Month?: any;
        GradeName?: any;
        ReportingToPositionName?: any;
        TotalVisits?: any;
        OutletsCovered?: any;
        MtpStatus?: any;
        EmployeePhone?: any;
    };
};

const MtpEmployeeDetailsCard: React.FC<DataProps> = ({ data }) => {
    return (
        <div style={styles.container}>
            <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", justifyContent: "center" }}>
                <div style={{ ...styles.imageContainer }}>
                    <img src="assets/images/user/profile_user.png" alt="Profile" width={'100%'} height={'100%'} />
                </div>
                <div style={styles.headerContainer}>
                    <p style={styles.nameText}>{`${data?.EmployeeName || ''} | ${data?.EmployeeCode || ''}`}</p>
                    <p style={styles.emailText}>{`${data?.EmployeeEmail || '-'}`}</p>
                </div>
            </div>

            <div style={styles.detailsContainer}>
                <div style={styles.detailItem}>
                    <p style={styles.label}>Positions</p>
                    <p style={styles.value}>{`${data?.PositionName || '-'}`}</p>
                </div>
                <div style={styles.detailItem}>
                    <p style={styles.label}>MTP month</p>
                    <p style={styles.value}>{`${data?.Month || '-'}` }</p>
                </div>
                <div style={styles.detailItem}>
                    <p style={styles.label}>Grade</p>
                    <p style={styles.value}>{`${data?.GradeName || '-'}`}</p>
                </div>
                <div style={styles.detailItem}>
                    <p style={styles.label}>Report to</p>
                    <p style={styles.value}>{`${data?.ReportingToPositionName || '-'}`}</p>
                </div>
                <div style={styles.detailItem}>
                    <p style={styles.label}>Total Visits</p>
                    <p style={styles.value}>{`${data?.TotalVisits || '-'}`}</p>
                </div>
                <div style={styles.detailItem}>
                    <p style={styles.label}>Outlet Covered</p>
                    <p style={styles.value}>{`${data?.OutletsCovered || '-'}`}</p>
                </div>
                <div style={styles.detailItem}>
                    <p style={styles.label}>MTP Status</p>
                    <p style={styles.value}>{`${data?.MtpStatus || '-'}`}</p>
                </div>
                <div style={styles.detailItem}>
                    <p style={styles.label}>Contact</p>
                    <p style={styles.value}>{`${data?.EmployeePhone || '-'}`}</p>
                </div>
            </div>
        </div>
    );
};

export default MtpEmployeeDetailsCard;
